
$('.playIcons').click(function(){
    var videoSrc = $(this).attr('data-src');
    if(videoSrc==''){
            $(this).parents('.coverText').fadeOut();
            
            $(this).parents('.coverText').siblings('img').fadeOut();
            $(this).parents('.coverText').siblings('video').fadeIn().trigger('play')
    }else{
            $('.videoInfor').append('<iframe src="'+videoSrc+'" class="js-youtube" allow="autoplay; encrypted-media" allowfullscreen="" ></iframe>')
    }
  })